import { counsellings_api_home_url } from 'mk/urls/functions';
import {
    counsellingsHomeFetch,
    CounsellingsHomeFetchNormalizedResponse,
    CounsellingsHomeFetchRequestAction,
    COUNSELLINGS_HOME_LOAD,
} from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome.actions';
import { TopicStats } from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome.reducers';
import { forumUpdateComplaintsStatistics } from 'mk2/apps/forum/actions';
import {
    ComplaintsStatisticsPerPost,
    CounsellingEntity,
    CounsellingSchema,
    PostEntity,
    PostSchema,
    TopicSchema,
} from 'mk2/apps/forum/schemas';
import { normalizeError, XHRAction } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { normalize } from 'normalizr';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('counsellings/CounsellingsHome.sagas');

interface ApiResponsePosts {
    body: {
        posts: PostEntity[];
        hasNext: number;
        hasPrevious: number;
        notificationsOn: number[];
        complaintsStatistics: ComplaintsStatisticsPerPost;
        topicStats: TopicStats;
        lastVisitCounts: {
            subscribedCounsellings: TopicStats;
        }
        counsellings: CounsellingEntity;
        totalAnswers: number;
        resultsCount: number;
    };
}

function* load({ after, query, xhr }: CounsellingsHomeFetchRequestAction & XHRAction) {
    yield put(counsellingsHomeFetch.request(query, after));

    try {
        const response: ApiResponsePosts = yield call(
            () => xhr.get(counsellings_api_home_url(), { after, q: query }),
        );

        const normalizedResponse: CounsellingsHomeFetchNormalizedResponse = normalize(response.body, {
            posts: [PostSchema],
            followingTopics: [TopicSchema],
            topics: [TopicSchema],
            counsellings: [CounsellingSchema],
        });

        yield put(forumUpdateComplaintsStatistics(response.body.complaintsStatistics));
        yield put(counsellingsHomeFetch.success(
            query,
            after,
            response.body.hasNext,
            response.body.hasPrevious,
            response.body.notificationsOn,
            response.body.topicStats,
            response.body.lastVisitCounts.subscribedCounsellings,
            response.body.totalAnswers,
            response.body.resultsCount,
            normalizedResponse,
        ));
    } catch (error) {
        logger.error(error);

        yield put(counsellingsHomeFetch.failure(query, after, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(COUNSELLINGS_HOME_LOAD, load),
    ]);
}
